import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { PatrolPolicyPresetId } from '../../../models/patrol-discord-cockpit.model';
import { PatrolRobloxCockpitService } from '../../../services/patrol-roblox-cockpit.service';
import { PATROL_KIND_SPEECH_DEFAULT_I18N_PARAMS } from '../../../constants/patrol-kind-speech-defaults';

const UNIVERSE_DEFAULT_PRESETS: ReadonlyArray<PatrolPolicyPresetId> = [
  'relaxed',
  'standard',
  'strict',
];

const CHANNEL_PRESETS = [
  'inherit',
  'off',
  'relaxed',
  'standard',
  'strict',
] as const;

@Component({
  selector: 'app-patrol-roblox-policies',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslatePipe],
  templateUrl: './patrol-roblox-policies.component.html',
  styleUrl: './patrol-roblox-policies.component.scss',
})
export class PatrolRobloxPoliciesComponent {
  #cockpit = inject(PatrolRobloxCockpitService);

  readonly settings = this.#cockpit.guildSettings;
  readonly discordChannels = this.#cockpit.discordChannels;
  readonly isLoadingPolicies = this.#cockpit.isLoadingPolicies;
  readonly isSavingPolicies = this.#cockpit.isSavingPolicies;
  readonly policiesError = this.#cockpit.policiesError;
  readonly universeDefaultPresets = UNIVERSE_DEFAULT_PRESETS;
  readonly channelPresets = CHANNEL_PRESETS;
  readonly kindSpeechDefaultParams = PATROL_KIND_SPEECH_DEFAULT_I18N_PARAMS;

  channelPolicyValue(discordChannelId: string): string {
    return this.#cockpit.channelPolicyForChannel(discordChannelId);
  }

  presetDescriptionKey(
    presetId: PatrolPolicyPresetId,
  ): string | null {
    if (presetId === 'relaxed' || presetId === 'standard' || presetId === 'strict') {
      return `app.patrol.roblox.cockpit.presets.descriptions.${presetId}`;
    }
    return null;
  }

  onDefaultPolicyChange(value: string): void {
    void this.#cockpit.updateDefaultPolicy(value as PatrolPolicyPresetId);
  }

  onToggle(
    key:
      | 'linkRequired'
      | 'reputationEnabled'
      | 'failClosedOnAiOutage'
      | 'notificationsEmail'
      | 'kindSpeechEnabled',
    checked: boolean,
  ): void {
    void this.#cockpit.updateGuildSetting(key, checked);
  }

  onChannelPolicyChange(discordChannelId: string, value: string): void {
    void this.#cockpit.updateChannelPolicy(
      discordChannelId,
      value as PatrolPolicyPresetId | 'inherit',
    );
  }
}
